<div class="generalDiv">
  <div class="auth-background">
    <app-background></app-background>
    <div class="auth-box">
      <!-- Logo -->
      <img src="Logo.svg" alt="Logo" class="auth-logo" />

      <!-- Título -->
      <p class="auth-text">Sin Autorización</p>

      <!-- Mensaje -->
      <p class="auth-message">
        Tu cuenta no está autorizada para acceder a esta página
      </p>

      <!-- Botón -->
      <a routerLink="/dashboard" class="auth-button">
        <div class="button-content">
          <div class="button-text">Volver</div>
        </div>
      </a>
    </div>
  </div>
</div>
